import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const tags = ['Técnica', 'Táctica', 'Planificación', 'Set Piece', 'Phase Play', 'Defensa', 'Físico', 'Nutrición', 'Recuperación', 'Mentalidad', 'Liderazgo', 'Scouting', 'Metodología'];
const skills = ['Scrum técnico', 'Line-out', 'Ruck y Maul', 'Defensa en línea', 'Kick territorial', 'Lectura del juego', 'Comunicación táctica', 'Físico específico rugby', 'Nutrición para partidos', 'Scouting rival', 'Mentalidad competitiva', 'Planificación de temporada'];
export function Overview() {
  return <section className="py-14 md:py-24 bg-rugby-green-900 relative border-t border-rugby-green-800" data-id="element-255">
      <div className="container mx-auto px-4" data-id="element-256">
        <div className="max-w-5xl mx-auto" data-id="element-257">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-8 md:mb-12" data-id="element-258">
            <h2 className="text-3xl md:text-5xl font-display text-white mb-2 md:mb-4" data-id="element-259">
              SISTEMA N°1 EN ARGENTINA
            </h2>
            <p className="text-base md:text-xl text-slate-300 px-2" data-id="element-260">
              El kit de desarrollo más completo para el rugbier argentino.
            </p>
            <p className="text-rugby-gold-400 text-xs md:text-base font-medium mt-1 md:mt-2 px-2" data-id="element-261">
              Sistema completo · 6 Tomos + 6 Bonos · Amateur y Semiprofesional ·
              Todo resuelto.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 md:gap-8 mb-8 md:mb-16" data-id="element-262">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="lg:col-span-5 flex flex-col justify-center gap-3 md:gap-6" data-id="element-263">
              <div className="flex gap-3 md:gap-4" data-id="element-264">
                <div className="bg-rugby-green-950 border border-rugby-gold-500/30 p-4 md:p-6 rounded-xl flex-1 text-center" data-id="element-265">
                  <span className="block text-3xl md:text-4xl font-display text-rugby-gold-400 mb-0.5 md:mb-1" data-id="element-266">
                    +480
                  </span>
                  <span className="text-xs md:text-sm text-slate-400 uppercase tracking-wider font-semibold" data-id="element-267">
                    Páginas
                  </span>
                </div>
                <div className="bg-rugby-green-950 border border-rugby-gold-500/30 p-4 md:p-6 rounded-xl flex-1 text-center" data-id="element-268">
                  <span className="block text-3xl md:text-4xl font-display text-rugby-gold-400 mb-0.5 md:mb-1" data-id="element-269">
                    60+
                  </span>
                  <span className="text-xs md:text-sm text-slate-400 uppercase tracking-wider font-semibold" data-id="element-270">
                    Ejercicios
                  </span>
                </div>
              </div>

              <div className="bg-rugby-green-800/50 p-4 md:p-6 rounded-xl border border-rugby-green-700" data-id="element-271">
                <p className="text-white text-sm md:text-base font-medium mb-3 md:mb-4 text-center" data-id="element-272">
                  Funciona desde hoy en tu club, cancha o patio.
                </p>
                <div className="flex flex-wrap gap-1.5 md:gap-2 justify-center" data-id="element-273">
                  {tags.map((tag, i) => <motion.span key={i} whileHover={{
                  scale: 1.08,
                  backgroundColor: 'rgba(212,175,55,0.15)'
                }} className="bg-rugby-green-950 text-slate-300 text-[11px] md:text-xs px-2.5 md:px-3 py-1 md:py-1.5 rounded-full border border-rugby-green-700 cursor-default" data-id="element-274">
                      {tag}
                    </motion.span>)}
                </div>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="lg:col-span-7 bg-rugby-green-950 p-5 md:p-8 rounded-2xl border border-rugby-green-700" data-id="element-275">
              <h3 className="text-base md:text-xl font-bold text-white mb-4 md:mb-6" data-id="element-276">
                Habilidades y conceptos incluidos:
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-2.5 md:gap-y-4 gap-x-6" data-id="element-277">
                {skills.map((skill, i) => <div key={i} className="flex items-center gap-2.5 md:gap-3" data-id="element-278">
                    <div className="bg-rugby-gold-500/20 p-1 rounded-full flex-shrink-0" data-id="element-279">
                      <Check size={12} className="text-rugby-gold-400" data-id="element-280" />
                    </div>
                    <span className="text-slate-200 text-sm md:text-base" data-id="element-281">
                      {skill}
                    </span>
                  </div>)}
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}